module.exports = __webpack_public_path__ + "img/like.ebd16051.png";